/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactType } from './contactType';
import { UsageKind } from './usageKind';

/**
 * Communication channel like e-mail, phone, etc.   (bipro-partner::Kommunikationsverbindung)
 */
export interface Contact {
  contactType: ContactType;
  usageKind: UsageKind;
  email?: string;
  /**
   * Phone number with Germany specific prefix, no country code or \"+\".   Examples: 0172123456, 030123456, 0173 123456
   */
  phone?: string;
  /**
   * In case of multiple contact channels per partner, this may indicate the preferred contact.  Otherwise always the first contact is used.   (german: bevorzugter Kontakt)   (bipro-partner::BevorzugteKommunikationsverbindung)
   */
  preferredContact?: boolean;
}
export namespace Contact {}
